import { leaderboardUidCached } from "model/Leaderboard/Leaderboard";
import { Pickem } from "model/Pickem/Pickem";
import { useEffect, useState } from "react";
import { selectTournament } from "selectors/Tournament";
import {
  selectFetchingLeaderboardUsers,
  selectLeaderboard,
} from "selectors/Leaderboard";
import { EmptyGrowPanelText, ErrorText } from "styles/text";
import { selectClosedTournamentPickemDetails } from "selectors/PickemDetails";
import { PickemDetails } from "model/PickemDetails/PickemDetails";
import { isMatchemDetails } from "model/PickemDetails/Matchem/Details";
import { PickemUserMatchemPicks } from "./Matchem/PickemUserMatchemPicks";
import { isRankemDetails } from "model/PickemDetails/Rankem/Details";
import { PickemUserRankemPicks } from "./Rankem/PickemUserRankemPicks";
import {
  isSegmentLeaderboardUser,
  LeaderboardPart,
  sumLeaderboardPartPoints,
} from "model/Leaderboard/User/SegmentLeaderboardUser";
import { UserPicksContainer } from "./styles";
import { isBracketemDetails } from "model/PickemDetails/Bracketem/Details";
import { PickerUserBracketemPicks } from "./Bracketem/PickemUserBracketemPicks";
import { Panel } from "components/Panel/Panel";
import { fetchLeaderboardUsersByUid } from "app/slices/LeaderboardSlice";
import { getUserPickems } from "db/info/pickemInfo";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { shallowEqual } from "react-redux";
import { CenterFlexRow } from "styles/layout";

interface Props {
  uid: string;
  tournamentId: string;
}

export const BeaconUserPicks = ({ uid, tournamentId }: Props) => {
  const dispatch = useAppDispatch();
  const [pickems, setPickems] = useState<{ [pickemId: string]: Pickem }>({});
  const userUid = useAppSelector((state) => state.user.uid);
  const isAuthenticatedUser = uid === userUid;
  const pickemDetails =
    useAppSelector(
      (state) =>
        selectClosedTournamentPickemDetails(
          state,
          tournamentId,
          isAuthenticatedUser
        ),
      shallowEqual
    ) ?? [];

  // todo - bad longterm
  const tournament = useAppSelector((state) =>
    selectTournament(state, tournamentId)
  );

  const div1Leaderboard = useAppSelector((state) =>
    selectLeaderboard(state, `${tournamentId}Div1`)
  );

  const div2Leaderboard = useAppSelector((state) =>
    selectLeaderboard(state, `${tournamentId}Div2`)
  );

  const poLeaderboard = useAppSelector((state) =>
    selectLeaderboard(state, `${tournamentId}Playoffs`)
  );

  const prLeaderboard = useAppSelector((state) =>
    selectLeaderboard(state, `${tournamentId}Promo`)
  );

  const fetchingLbUsers = useAppSelector(selectFetchingLeaderboardUsers);
  useEffect(() => {
    if (
      !!div1Leaderboard &&
      !!uid &&
      !leaderboardUidCached(div1Leaderboard, uid) &&
      fetchingLbUsers === "idle"
    ) {
      dispatch(
        fetchLeaderboardUsersByUid({
          leaderboardId: `${tournamentId}Div1`,
          uids: [uid],
        })
      );
    } else if (
      !!div2Leaderboard &&
      !!uid &&
      !leaderboardUidCached(div2Leaderboard, uid) &&
      fetchingLbUsers === "idle"
    ) {
      dispatch(
        fetchLeaderboardUsersByUid({
          leaderboardId: `${tournamentId}Div2`,
          uids: [uid],
        })
      );
    } else if (
      !!poLeaderboard &&
      !!uid &&
      !leaderboardUidCached(poLeaderboard, uid) &&
      fetchingLbUsers === "idle"
    ) {
      console.log("Fetch Playoffs");
      dispatch(
        fetchLeaderboardUsersByUid({
          leaderboardId: `${tournamentId}Playoffs`,
          uids: [uid],
        })
      );
    } else if (
      !!prLeaderboard &&
      !!uid &&
      !leaderboardUidCached(prLeaderboard, uid) &&
      fetchingLbUsers === "idle"
    ) {
      console.log("Fetch Promo");
      dispatch(
        fetchLeaderboardUsersByUid({
          leaderboardId: `${tournamentId}Promo`,
          uids: [uid],
        })
      );
    }
  }, [uid, tournamentId, fetchingLbUsers]);

  const div1leaderboardUser = div1Leaderboard?.users[uid];
  const div2leaderboardUser = div2Leaderboard?.users[uid];
  const poleaderboardUser = poLeaderboard?.users[uid];
  const prleaderboardUser = prLeaderboard?.users[uid];
  console.log(poleaderboardUser);
  console.log(prleaderboardUser);
  useEffect(() => {
    async function getPicks() {
      setPickems(
        await getUserPickems(
          uid,
          tournamentId,
          pickemDetails.map((p) => p.pickemId)
        )
      );
    }

    getPicks();
  }, [uid, tournamentId]);

  if (!tournament) {
    return (
      <Panel>
        <EmptyGrowPanelText>Unable to find tournament</EmptyGrowPanelText>
      </Panel>
    );
  }

  if (Object.keys(pickems).length === 0) {
    return (
      <Panel>
        <EmptyGrowPanelText>
          User has no picks for the selected filter
        </EmptyGrowPanelText>
      </Panel>
    );
  }

  return (
    <UserPicksContainer>
      {pickemDetails.map((details) => {
        const userPicks = pickems[details.pickemId];
        if (!userPicks) {
          return <></>;
        }

        let leaderboardPart: LeaderboardPart | undefined;
        if (details.pickemId.includes("Div1")) {
          leaderboardPart =
            !!div1leaderboardUser &&
            isSegmentLeaderboardUser(div1leaderboardUser)
              ? div1leaderboardUser.parts.find(
                  (p) => p.pickemId === details.pickemId
                )
              : undefined;
        }

        if (details.pickemId.includes("Div2")) {
          leaderboardPart =
            !!div2leaderboardUser &&
            isSegmentLeaderboardUser(div2leaderboardUser)
              ? div2leaderboardUser.parts.find(
                  (p) => p.pickemId === details.pickemId
                )
              : undefined;
        }

        if (details.pickemId === "Playoffs") {
          leaderboardPart =
            !!poleaderboardUser && isSegmentLeaderboardUser(poleaderboardUser)
              ? poleaderboardUser.parts.find(
                  (p) => p.pickemId === details.pickemId
                )
              : undefined;
        }

        if (details.pickemId === "Promo") {
          leaderboardPart =
            !!prleaderboardUser && isSegmentLeaderboardUser(prleaderboardUser)
              ? prleaderboardUser.parts.find(
                  (p) => p.pickemId === details.pickemId
                )
              : undefined;
        }

        const points = sumLeaderboardPartPoints(leaderboardPart);
        const header = `${details.name} ${
          points !== undefined ? ` - ${points}` : ""
        }`;
        return (
          <>
            <Panel
              key={`${details.tournamentId} ${details.segmentId} ${details.pickemId}`}
              header={header}
              bottomMargin={false}
            >
              {mapUserPicks(tournamentId, details, userPicks, leaderboardPart)}
            </Panel>
            {!!details.resultsMessage && (
              <Panel type="information">
                <CenterFlexRow style={{ padding: "5px" }}>
                  {details.resultsMessage}
                </CenterFlexRow>
              </Panel>
            )}
          </>
        );
      })}
    </UserPicksContainer>
  );
};

const mapUserPicks = (
  tournamentId: string,
  details: PickemDetails,
  pickem: Pickem,
  leaderboardPart: LeaderboardPart | undefined
) => {
  if (isBracketemDetails(details)) {
    return (
      <PickerUserBracketemPicks
        pickem={pickem}
        bracketemDetails={details}
        leaderboardPart={leaderboardPart}
      />
    );
  }

  if (isMatchemDetails(details)) {
    return (
      <PickemUserMatchemPicks
        pickem={pickem}
        tournamentId={tournamentId}
        leaderboardPart={leaderboardPart}
      />
    );
  }

  if (isRankemDetails(details)) {
    return (
      <PickemUserRankemPicks
        pickem={pickem}
        rankemDetails={details}
        leaderboardPart={leaderboardPart}
      />
    );
  }

  return <ErrorText>Unsupported Pickem Type</ErrorText>;
};
